<template>
  <div class="noData">
    <img src="@/assets/images/common/kuang.png" alt="" />
    <span>{{ tip }}</span>
  </div>
</template>

<script>
export default {
  name: "ExperimentPlatformNodata",
  props: {
    tip: {
      default: "暂无数据",
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.noData {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 20px 0;
  img {
      width: 200px;
  }
  span {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    margin-top: 20px;
  }
}
</style>